import { Box } from '@mui/material';
import React, { useEffect, useRef } from 'react';

import { studyflix } from '../../../../../constants';

interface VideoPlayerStudyflixProps {
	studyflixId: number;
	setIsReady?: (arg: boolean) => void;
}

const VideoPlayerStudyflix: React.FC<VideoPlayerStudyflixProps> = ({ studyflixId, setIsReady }) => {
	const containerRef = useRef<HTMLDivElement>(null);

	const useRenderStudyflixVideo = () => {
		const dataId = studyflixId.toString();

		const createScriptElement = (url: string) => {
			const scriptElement = document.createElement('script');
			scriptElement.src = url;
			scriptElement.setAttribute('data-id', dataId);
			scriptElement.setAttribute('data-partner', studyflix.dataPartner);
			scriptElement.async = true;

			return scriptElement;
		};

		// biome-ignore lint/correctness/useExhaustiveDependencies: pre-Biome hook deps kept as-is; changing the deps list alters effect timing
		useEffect(() => {
			const studyFlixIframe = createScriptElement(studyflix.url);
			containerRef?.current?.appendChild(studyFlixIframe);

			if (setIsReady) {
				setIsReady(true);
			}

			return () => {
				// This removes the player on unmount
				if (containerRef?.current?.children[0])
					containerRef.current.removeChild(containerRef.current.children[0]);
			};
		}, [dataId]);

		return (
			<Box
				sx={{
					position: 'relative',
					width: '100%',
					height: '0',
					paddingBottom: 'calc(486/864 * 100%)', // 486/864 is the aspect ratio for the videos
				}}
				data-testid="studyflix-player-container"
			>
				<Box
					sx={{
						position: 'absolute',
						width: '100%',
					}}
					data-testid="video-player"
					ref={containerRef}
				/>
			</Box>
		);
	};

	return <>{useRenderStudyflixVideo()}</>;
};

export const StudyflixError: React.FC<{ thumbnail: string }> = ({ thumbnail }) => {
	return (
		<Box
			component="img"
			src={thumbnail}
			data-testid={'studyflix-error__thumbnail'}
			sx={{
				width: '100%',
			}}
		/>
	);
};

export default VideoPlayerStudyflix;
